<div class="container-custom">
  <div class="branding d-flex">
    <img class="mx-auto" id="home-image"/>
  </div>
  <div class="header">
    <h1 class="dsgsans">{{"Sign in to AMP" | uppercase}}</h1>
  </div>
  <div class="sidebar"></div>
  <div class="page-background d-flex">
    <div class="d-flex flex-row my-auto mx-auto">
      <img id="amp-logo" class="col-5 justify-content-start pr-4"/>
      <div class="text-container justify-content-center flex-column">
        <h2 class="login-page-text dsgsans"><b>AMP APP</b></h2>
        <h2 class="login-page-text dsgsans"><b>ANALYZE&bull;MANAGE&bull;PLAN</b></h2>
        <h2 class="login-page-text dsgsans"><b>Brand Standards Facility Management</b></h2>
        <dcsg-mat-spinner-button
          (click)="!isLoading && login()"
          btnClass="dcsg-button dcsg-button-primary w-100"
          title="Sign In"
          btnType="submit"
          [showSpinner]="isLoading">
        </dcsg-mat-spinner-button>
      </div>

    </div>
  </div>
</div>
